import React from 'react';

const Navbar = ({ currentPath = '/', onNavigate, projectsLabel = 'projects' }) => {
  // Determine which menu items to show based on current path
  const menuItems = [
    { path: '/', label: 'home', showOn: ['/projects', '/about'] }

  ]
      {/* ,
    { path: '/projects', label: projectsLabel, showOn: ['/', '/home', '/about'] }, // Use dynamic label
    { path: '/about', label: 'about', showOn: ['/', '/home', '/projects'] }*/}
     
  // Filter menu items based on current path
  const visibleMenuItems = menuItems.filter(item => {
    // Handle both '/' and '/home' as the same page
    const normalizedPath = currentPath === '/home' ? '/' : currentPath;
    return item.showOn.includes(normalizedPath);
  });
  
  const handleNavigation = (path) => {
    if (onNavigate) {
      onNavigate(path);
    }
  };
  
  return (
    <nav className="fixed top-0 left-0 w-full px-8 py-6 z-50 pointer-events-none">
      <div className="flex justify-between items-center">
        {/* Logo/Brand */}
        <div className="flex items-center pointer-events-auto">
          <button 
            onClick={() => handleNavigation('/')}
            className="text-2xl font-bold text-black hover:opacity-70 transition-opacity cursor-pointer"
          >
            Horoboro
          </button>
          <span className="mx-4 text-2xl font-light text-black">|</span>
          <span className="text-2xl font-light text-black">Ariel Monti</span>
        </div>
        
        {/* Navigation Menu */}
        <div className="flex items-center space-x-8 pointer-events-auto">
          {visibleMenuItems.map((item) => (
            <button
              key={item.path}
              onClick={() => handleNavigation(item.path)}
              className="bg-[#ebe9dc] rounded-lg p-2 text-xl font-light text-black hover:opacity-70 transition-opacity cursor-pointer"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;